export const load = () => ({
	title: 'Why We Laser Measure Windows',
	showTitle: true,
});
